/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import { Text, View } from 'react-native';

import styles from '../../styles';

class PublisherQuestions extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherQuestions';
  }

  render() {
    return (
      <View
        style={styles.view.headless}
      >
        <Text>
          PublisherQuestions
        </Text>
      </View>
    );
  }
}

export default PublisherQuestions;
